import { EnumFiscalResidence } from '@blank/api'
import { CountryConfig, EnumHomeCountryCode } from '../../types'

export const CA_FR_COUNTRY_CONFIG: CountryConfig = {
  canAddCompanyDataManually: false,
  companyIdentificationNumberLength: 9,
  shouldChooseDomiciliationOnSignup: false,
  isBeta: false,
  canAddEnterpriseMandate: true,
  shouldDisplayUserFeedbackButton: false,
  isSponsorshipEnabled: false,
  increaseTransferLimitTypeformId: 'M4GACcvJ',
  feedbackTypeformId: '',
  accountClosingTypeformId: 'PQMgX8c8',
  shouldDisplayAdditionalTouOnSelectOffer: false,
  fiscalResidenceOptions: [EnumFiscalResidence.FRA, EnumFiscalResidence.USA],
  homeCountryCode: EnumHomeCountryCode.FRA,
  invoicing: {
    canCreateEstimateDocument: true,
    canAddFiscalTaxesToDocument: false,
    canAddFiscalStampToDocument: false,
    shouldSelectVATExonerationCode: false,
  },
  shouldDisplayAverageBalanceDocuments: false,
  shouldBuildMicroEnterpriseCreationURLWithParams: true,
  whatsAppSupportNumber: undefined,
  shouldCustomizeCardFraudInsuranceRedirectionUrl: false,
  fileComplaintTypeformId: 'm9QIeY1f',
  shouldDisplayZendeskMessagingWidget: true,
  zendeskScriptKey: 'a0a180f1-b627-4ac8-a4f1-48f45cd17b25',
  hasOptionalConsents: false,
}
